export const BorrowersDeliveryStepTestIds = {
  ROOT: 'prepare-disclosures-borrowers-delivery-step',
  DISCLAIMER: 'prepare-disclosures-borrowers-delivery-disclaimer',
  SIGNER_LIST: 'prepare-disclosures-signer-list',
  SIGNER_ROW: 'prepare-disclosures-signer-row',
  SIGNER_EMAIL: 'prepare-disclosures-signer-email',
  SIGNER_FACTOR: 'prepare-disclosures-signer-factor',
  SIGNER_ECONSENT: 'prepare-disclosures-signer-econsent',
  SIGNER_DELIVERY: 'prepare-disclosures-signer-delivery',
  SIGNER_DELIVERY_SELECT: 'prepare-disclosures-signer-delivery-select',
  getSignerDeliveryOptionId: value => `prepare-disclosures-signer-delivery-option-${value}`,
  SIGNER_MAIL_HINT: 'prepare-disclosures-signer-mail-hint',
  NBE_NOTE: 'prepare-disclosures-nbe-note',
  INTENT_TO_PROCEED: 'prepare-disclosures-intent-to-proceed',
  ECD_IMPACT: 'prepare-disclosures-ecd-impact',
  ECD_IMPACT_DATE: 'prepare-disclosures-ecd-impact-date',
};
